import React, { useEffect, useState } from "react";

// lib
import Shipment from "../../../../../../lib/fulfillment/shipment";
import moment from "moment";

// components
import { Button, Divider, Modal, Space, Timeline, Typography, Input, message } from "antd";
import { SaveOutlined } from "@ant-design/icons";

// hooks
import { useUpdateShipment } from "../../../../../../hooks/api/fulfillment/shipment";

// styles
import { Container, InputWrapper } from "./styles";

// types
import { Fulfillment } from "@secondcloset/types";
import { BaseNote } from "@secondcloset/types/src/_common";
type ShipmentType = Fulfillment.Shipment<"V2">;

interface Props {
  visible: boolean;
  setVisible: (visible: boolean) => void;
  shipment: ShipmentType;
  onRefetch: () => void;
}

const { Text } = Typography;
const { TextArea } = Input;
const NotesModal: React.FC<Props> = ({ visible, setVisible, shipment, onRefetch }) => {
  const [note, setNote] = useState("");
  const { updateShipmentStatus, updateShipment } = useUpdateShipment();
  const notes: Partial<BaseNote>[] = Shipment.sortNotes(
    typeof shipment?.notes === "string" ? [{ text: shipment.notes }] : shipment.notes
  );

  const error = updateShipmentStatus.error;

  useEffect(() => {
    if (error) message.error(error);
  }, [error]);

  const handleSaveNote = (newNotes: string) => {
    const body = { notes_attributes: [{ text: newNotes }] };
    updateShipment(shipment?.id || "", body).then(() => {
      message.success("Notes saved successfully!");
      setNote("");
      onRefetch();
    });
  };

  return (
    <Modal title="Shipment Notes" visible={visible} onCancel={() => setVisible(false)} footer={null}>
      <Container>
        <InputWrapper>
          <TextArea
            allowClear
            placeholder="Enter a note."
            size="small"
            value={note}
            onChange={(e) => setNote(e.target.value)}
          />
          <Button
            type="primary"
            size="small"
            icon={<SaveOutlined />}
            onClick={() => handleSaveNote(note)}
            disabled={updateShipmentStatus.loading}
          >
            Save Note
          </Button>
        </InputWrapper>
        <Divider />
        <Timeline>
          {notes.map((note) => (
            <Timeline.Item key={note.id}>
              <Space direction="vertical" size={0}>
                <Text>{note.text}</Text>
                <Text type="secondary">
                  {note.user?.first_name} - {moment(note.created_at).format("lll")}
                </Text>
              </Space>
            </Timeline.Item>
          ))}
        </Timeline>
      </Container>
    </Modal>
  );
};

export default NotesModal;
